import React, { useEffect, useState } from "react";
import { Button } from "@mui/material";
import { userUpdate } from "../../graphql";
import { CURRENT_USER_QUERY, useAuthContext } from "../auth";
import { useMutation } from "@apollo/client";
import getaccessTokenSms from "../../services/smsService";

const SMS = () => {
  const { user } = useAuthContext();
  const [isConfigured, setIsConfigured] = useState(false);
  const [UpdateUser, { loading, data }] = useMutation(userUpdate, {
    refetchQueries: [
      {
        query: CURRENT_USER_QUERY,
      },
    ],
  });

  const get_gmail_access_token = localStorage.getItem("gmail_token");
  const get_gmail_refresh_token = localStorage.getItem("gmail_refresh_token");
  const get_outlook_access_token = localStorage.getItem("outlook_token");
  const get_outlook_refresh_token = localStorage.getItem("outlook_refresh_token");

  useEffect(() => {
    if (!loading && data) {
      window.location.reload();
    }
  }, [loading, data]);

  useEffect(() => {
    const smsAccessToken = localStorage.getItem("ring_central_token");
    setIsConfigured(!!smsAccessToken);
  }, []);

  const handleSMSLogin = () => {
    const clientId = process.env.REACT_APP_RING_CENTRAL_USER_ID;
    const redirectUri = `${window.location.origin}/setting`;
    const scope = "SMS";
    
    const authUrl = `https://platform.ringcentral.com/restapi/oauth/authorize?client_id=${clientId}&response_type=code&redirect_uri=${encodeURIComponent(redirectUri)}&scope=${encodeURIComponent(scope)}`;
    
    window.location.href = authUrl;
  };

  const handleSuccess = async (code) => {
    try {
      // Use the SMS service function
      getaccessTokenSms(code);

      // Wait a bit for the token to be stored
      setTimeout(async () => {
        const smsAccessToken = localStorage.getItem("ring_central_token");
        const smsRefreshToken = localStorage.getItem("ring_central_refresh_token");
        const smsUserData = localStorage.getItem("ring_central_user_data");

        if (smsAccessToken) {
          UpdateUser({
            variables: {
              data: {
                id: user.id,
                access_token_data: {
                  google_access_token: get_gmail_access_token || "",
                  google_refresh_token: get_gmail_refresh_token || "",
                  outlook_access_token: get_outlook_access_token || "",
                  outlook_refresh_token: get_outlook_refresh_token || "",
                  sms_access_token: smsAccessToken,
                  sms_refresh_token: smsRefreshToken || "",
                  mailchimp_user_field_mapping:
                    user.access_token_data?.mailchimp_user_field_mapping || "",
                },
              },
            },
          });
        }
      }, 1000);
    } catch (error) {
      console.error("Error exchanging authorization code for tokens:", error);
    }
  };

  // Check if we're returning from SMS OAuth
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');
    const error = urlParams.get('error');
    
    if (code && !error) {
      handleSuccess(code);
    }
  }, []);

  return (
    <Button variant="contained" onClick={handleSMSLogin}>
      {isConfigured ? "Reconfigure SMS" : "Connect SMS"}
    </Button>
  );
};

export default SMS;
